import { h, Fragment, Component } from "preact";
import { useMemo } from 'preact/hooks'
import { observer } from "mobx-react";

import {
  Banner,
//  Results as ResultsComponent,
  withStore,
  withController,
} from "@searchspring/snap-preact-components";

import { ProductCount } from '../FilterSummary/ProductCount'
import { Profile } from "../Profile/Profile";
import { ResultsComponent } from './ResultsComponent'
import { Toolbar } from "../Toolbar/Toolbar";
import { MediaQuery } from '../Helpers/MediaQuery'

import "./results.css";
import { FeaturedFilter } from "../FilterSummary/FeaturedFilter";

@withStore
@withController
@observer
export class Results extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector(".search-results-template-wrapper");

    if (templateWrapper) {
      templateWrapper.classList.add("some-results");
    }
  }

  render() {
    const { merchandising, results, pagination } = this.props.store;
    const controller = this.props.controller;
    const isSearchOrNativeTemplate = window.Resources.isSearchOrNativeTemplate;

    let leftColumnLayout = ""

    if(window.Resources.searchspring.toolbar.leftColumnLayout == 'false') {
      leftColumnLayout = ""
    } else {
      leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    }

    if(isSearchOrNativeTemplate == true) {
      return (
        <div class={(leftColumnLayout ? 'ss-results-left-column left-column-wrapper' : 'ss-results')}>
          <Banner content={merchandising.content} type="header" />
          <Banner content={merchandising.content} type="banner" />
  
          <FeaturedFilter />
          
          { !leftColumnLayout ? (
            <MediaQuery query="(min-width: 750px)">
              <div className="ss-results__top-wrapper--bg">
                <div className="ss-results__top-wrapper page-width">
                  <ProductCount />
                  <Toolbar />
                </div>
              </div>
            </MediaQuery>
          ) : (null)  
          }
  
          { !leftColumnLayout ? (
            <MediaQuery query="(max-width: 749px)">
              <div className="ss-results__top-wrapper--mobile-bg">
                <div className="page-width">
                  <Toolbar />
                  <ProductCount />
              </div>
            </div>
            </MediaQuery>
          ) : (null)
          }
  
  
          <div class="clear"></div>
  
          <Profile name="results" controller={controller}>
            { leftColumnLayout ? (
              <Toolbar leftColumnLayout='true' />
            ): (
              null
            )}
            <ResultsComponent
              className="page-width plp-result-grid"
              controller={controller}
              results={results}
            />
          </Profile>
  
          <div class="clear"></div>
        </div>
      );
    }
    else {
      return (
        <div class={(leftColumnLayout ? 'ss-results-left-column left-column-wrapper' : 'ss-results')}>
          <Banner content={merchandising.content} type="header" />
          <Banner content={merchandising.content} type="banner" />
  
          <FeaturedFilter />
          
          { !leftColumnLayout ? (
              <MediaQuery query="(min-width: 990px)">
              <div className="ss-results__top-wrapper page-width">
                {/* <ProductCount /> */}
                <Toolbar />
              </div>
            </MediaQuery>
          ) : (null)  
          }
  
          { !leftColumnLayout ? (
            <MediaQuery query="(max-width: 989px)">
            {/* <ProductCount /> */}
            <Toolbar />
            </MediaQuery>
          ) : (null)
          }
  
  
          <div class="clear"></div>
  
          <Profile name="results" controller={controller}>
            { leftColumnLayout ? (
              <Toolbar leftColumnLayout='true' />
            ): (
              null
            )}
            <ResultsComponent
              className="page-width plp-result-grid"
              controller={controller}
              results={results}
            />
          </Profile>
  
          <div class="clear"></div>
        </div>
      );
    }
  }
}

@withController
@withStore
@observer
export class NoResults extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper')

    if (templateWrapper) {
        templateWrapper.classList.add('no-results')
    }
}

  render() {
    const store = this.props.store;
    return null;
  }
}
 